module.exports = __webpack_public_path__ + "img/047be085787327ff01d42f42f47a6540.b2f0435f.png";